module.exports = __webpack_public_path__ + "img/streamer.19ef2da7.png";